import React from "react";
import "./pagination-controls.scss";

const pageSizes = [50, 100, 200];

export default function PaginationControls({ pagination, pageSize, onPageChange, onPageSizeChange }) {
  const currentPage = Number(pagination.current_page || 1);
  const lastPage = Math.max(1, Number(pagination.last_page || 1));
  const total = Number(pagination.total || 0);
  const from = total ? Number(pagination.from || (currentPage - 1) * pageSize + 1) : 0;
  const to = total ? Number(pagination.to || Math.min(currentPage * pageSize, total)) : 0;

  return (
    <div className="pagination-controls">
      <div className="pagination-controls__summary">
        <span>{total ? `${from}–${to} of ${total}` : "0 records"}</span>
        <label>
          Page size
          <select value={pageSize} onChange={(event) => onPageSizeChange(Number(event.target.value))}>
            {pageSizes.map((size) => <option key={size} value={size}>{size}</option>)}
          </select>
        </label>
      </div>

      <div className="pagination-controls__navigation">
        <button type="button" disabled={currentPage <= 1} onClick={() => onPageChange(currentPage - 1)}>Previous</button>
        <span>Page {currentPage} of {lastPage}</span>
        <button type="button" disabled={currentPage >= lastPage} onClick={() => onPageChange(currentPage + 1)}>Next</button>
      </div>
    </div>
  );
}
